import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import routes from '@/routes';
import { localizedRoute } from '@/utils/locale';

export function useMenuItems() {
	const { t } = useTranslation();

	const menuItems = useMemo(
		() => [
			{
				text: 'navigation.howTo',
				to: localizedRoute(routes.howTo)
			},
			{
				text: 'navigation.pricing',
				to: localizedRoute(routes.pricing)
			},
			{
				text: 'navigation.faqs',
				to: localizedRoute(routes.faqs)
			}
		],
		[t]
	);

	return menuItems;
}
